import React from "react";
import ContactUsContent from "../function-components/ContactUs";

function Contact() {
  return (
    <>
      <ContactUsContent />
    </>
  );
}

export default Contact;
